<script setup>
import { computed } from 'vue';
import InertiaPagination from './InertiaPagination.vue';

const props = defineProps({
    links: {},
    meta: {},
});

const paginator = computed(() => {
    return {
        first_page_url: props.links.first,
        last_page_url: props.links.last,
        next_page_url: props.links.next,
        prev_page_url: props.links.prev,
        from: props.meta.first,
        last_page: props.meta.last_page,
        links: props.meta.links,
        path: props.meta.path,
        per_page: props.meta.per_page,
        to: props.meta.to,
        total: props.meta.total,
    };
});

defineOptions({
    name: 'InertiaResourcePaginator',
});
</script>

<template>
    <InertiaPagination :paginator="paginator" />
</template>
